import { render } from "./Principal-dashboard.vue?vue&type=template&id=0d49f16e"
import script from "./Principal-dashboard.vue?vue&type=script&lang=js"
export * from "./Principal-dashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__